export default "/assets/images/the-big-sneeze.35865ea73526e688.jpg";